"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionPaymentMethod = exports.TransactionType = void 0;
var TransactionType;
(function (TransactionType) {
    TransactionType["PAYOUT"] = "payout";
    TransactionType["PAYMENT"] = "payment";
    TransactionType["REFUND"] = "refund";
    TransactionType["BALANCE"] = "balance";
    TransactionType["EXTERNAL_BANK_TRANSFER"] = "external_bank_transfer";
    TransactionType["EXTERNAL_CHEQUE"] = "external_cheque";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var TransactionPaymentMethod;
(function (TransactionPaymentMethod) {
    TransactionPaymentMethod["ALMA"] = "alma";
    TransactionPaymentMethod["MASTERCARD"] = "mc";
    TransactionPaymentMethod["VISA"] = "visa";
})(TransactionPaymentMethod = exports.TransactionPaymentMethod || (exports.TransactionPaymentMethod = {}));
//# sourceMappingURL=transaction.js.map